<template>
  <div>
    <Slick ref="slick" :options="slickOptions">
      <div
        v-for="(event, i) in events.slice(0, 3)"
        :key="i"
        class="slide__item"
      >
        <div class="slide__feat">
          <img
            :src="
              event.featuredImage != null ? event.featuredImage : defaultImage
            "
            class="slide__img rounded-10 mw-100"
            alt=""
          />
        </div>
        <div class="slide__content">
          <div class="slide__subtitle">Latest Events</div>
          <h2 class="slide__title">{{ event.name }}</h2>
          <p class="slide__description">
            {{ event.formatedDescription | decode | limit(200, "") }}
          </p>
          <router-link
            :style="{ color: primary }"
            :to="`${linkTextUrl + event.id}`"
            class="slide__cta"
          >
            {{ `Learn More` }}
          </router-link>
        </div>
      </div>
    </Slick>
  </div>
</template>

<script>
import Slick from "vue-slick";

export default {
  props: {
    events: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  async created() {
    let params = {
      number: 1,
      size: 3
    };
    await this.$store.dispatch(
      "fetchRecentEvents",
      `events?page[number]=${params.number}&page[size]=${params.size}`
    );
    // document.querySelector
  },
  components: {
    Slick
  },
  data() {
    return {
      slickOptions: {
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: false,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              centerMode: true
            }
          },
          {
            breakpoint: 576,
            settings: {
              centerMode: false
            }
          }
        ]
      },
      linkTextUrl: "events/",
      defaultImage: require("@/assets/media/backgrounds/default.jpg")
    };
  },
  methods: {
    next() {
      this.$refs.slick.next();
    },
    prev() {
      this.$refs.slick.prev();
    },
    reInit() {}
  }
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/mixins/_breakpoints.scss";
@import "node_modules/slick-carousel/slick/slick.scss";

.slick-slider.slick-dotted {
  margin-bottom: 0;
  .slick-slide {
    min-height: 420px;
    @include media-breakpoint-down(md) {
      box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.07);
      margin: 0 20px;
    }
    .slide__item {
      .slide__feat {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        max-height: 245px;
        overflow: hidden;
        position: relative;
        @include media-breakpoint-down(md) {
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          height: 400px;
          .slide__img {
            height: 100%;
            object-fit: cover;
          }
        }
        .slide__img {
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          width: 100%;
        }
      }
      .slide__content {
        padding: 18px 40px;
        .slide__subtitle {
          color: #a1a1a1;
          font-family: $font-family-base;
          font-size: 15px;
          line-height: 26px;
          margin-bottom: 5px;
        }
        .slide__title {
          font-family: $font-family-base;
          font-size: 20px;
          font-weight: 500;
          line-height: 26px;
          margin-bottom: 12px;
        }
        .slide__description {
          font-family: $font-family-base;
          line-height: 24px;
          margin-bottom: 15px;
          font-size: 14px;
        }
        .slide__cta {
          color: #51b67e;
          display: block;
          font-family: $font-family-base;
          line-height: 24px;
        }
      }
    }
  }
  .slick-slide {
    margin: 0 5px;
  }
  .slick-dots {
    bottom: 28px;
    display: flex;
    list-style-type: none;
    margin: 0;
    padding: 0;
    position: absolute;
    right: 30px;
    @include media-breakpoint-down(md) {
      opacity: 0;
    }
    li {
      background-color: #e1faf4;
      border: 0;
      border-radius: 50%;
      color: transparent;
      display: block;
      font: 0/0 a;
      height: 10px;
      margin-right: 7px;
      overflow: hidden;
      text-shadow: none;
      width: 10px;
      &.slick-active,
      &:hover {
        button {
          background-color: var(--primary, $brand-primary);
        }
      }
      &:last-child {
        margin-right: 0;
      }
      button {
        background-color: #e1faf4;
        border: 0;
        cursor: pointer;
        display: block;
        height: 100%;
        transition: background-color 0.2s ease-in;
        width: 100%;
      }
    }
  }
}
</style>
